<div mat-dialog-title>
  <wai-dataroom-browser-breadcrumbs [dataroomBrowser]="dataroomBrowser"></wai-dataroom-browser-breadcrumbs>
</div>

<div mat-dialog-content class="content">
  <mat-divider></mat-divider>
  <div mat-subheader>{{ 'INTL_PRODUCT_DATAROOM_LABEL_FOLDERS' | translate }}</div>
  <wai-dataroom-browser
    #dataroomBrowser
    [service]="dialogData.service"
    [hiddenNodeIds]="[dialogData.id]"
    [selectableNodeTypes]="['folder']"
  ></wai-dataroom-browser>
  <mat-divider></mat-divider>
</div>

<div mat-dialog-actions class="footer">
  <div fxLayoutAlign="end center">
    <button type="button" mat-button [mat-dialog-close]="null">
      <mat-icon>block</mat-icon> <span class="button-label">{{ 'INTL_CANCEL' | translate }}</span>
    </button>
    <button type="submit" mat-raised-button color="primary" (click)="submit()">
      <span class="button-label">{{ 'INTL_PRODUCT_DATAROOM_ACTION_MOVE_HERE' | translate }}</span>
    </button>
  </div>
</div>
